import { Component, OnInit, Injector } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ComponentStore } from "@ngrx/component-store";
import { Store } from "@ngrx/store";
import {
  app_mst_role_RowClass,
  TenantRoleService,
  PricingSchemeService,
  ClientSidePermissionPricingSchemeRoleLinkContainerModel,
} from "blg-akaun-ts-lib";
import { PermissionFacade } from "../../../../../../../modules/permission/facades/permission.facade";
import { PermissionStates } from "../../../../../permission-controller/root";
import { RolePermSelectors } from "../../../../../../../modules/permission/role-permissions-controller/selectors";
import { RolePricingSchemeLinkActions } from "../../../../../../../modules/permission/role-pricing-scheme-link-controler/actions";
import { SessionSelectors } from "../../../../../../../modules/session/session-controller/selectors";
import { SessionStates } from "../../../../../../../modules/session/session-controller/states";
import { ViewColumnComponent } from "../../../../../../../view-column.component";
import { AppConfig } from "../../../../../../../visa";
import { SubSink } from "subsink2";
import { TranslateService } from "@ngx-translate/core";

interface LocalState {
  deactivateReturn: boolean;
}

@Component({
  selector: "app-add-pricing-scheme-link",
  templateUrl: "./add-pricing-scheme-link.component.html",
  styleUrls: ["./add-pricing-scheme-link.component.css"],
  providers: [ComponentStore],
})
export class AddPricingSchemeLinkComponent extends ViewColumnComponent {
  protected readonly index = 8;
  private localState: LocalState;

  readonly localState$ = this.viewColFacade.selectLocalState(this.index);
  readonly deactivateReturn$ = this.componentStore.select(
    (state) => state.localState.deactivateReturn
  );
  readonly AppletLoginSubjectLink$ = this.sessionStore.select(
    SessionSelectors.selectAppletLoginSubjectLink
  );
  readonly userRank$ = this.sessionStore.select(
    SessionSelectors.selectUserRank
  );

  appletGuid = sessionStorage.getItem("appletGuid");

  prevIndex: number;
  private prevLocalState: any;
  public form: FormGroup;
  private subs = new SubSink();
  newRoleArr: app_mst_role_RowClass[] = [];
  roleArr: app_mst_role_RowClass[] = [];
  newPricingSchemeArr: any[] = [];
  pricingSchemeArr: any[] = [];
  tenantGuid: any;
  rank: any;
  roleGuid: string;

  //translation variable
  title: string;
  pricing_scheme_text: string;
  select_pricing_scheme_text: string;
  invalid_entry: string;
  back_button: string;
  save_button: string;

  constructor(
    private tenantRoleService: TenantRoleService,
    private pricingSchemeService: PricingSchemeService,
    private viewColFacade: PermissionFacade,
    private fb: FormBuilder,
    private readonly sessionStore: Store<SessionStates>,
    private store: Store<PermissionStates>,
    private readonly componentStore: ComponentStore<{ localState: LocalState }>,
    private injector: Injector
  ) {
    super();
    const translateService = this.injector.get(TranslateService, null);
    if (translateService) {
      translateService.get('labels').subscribe(res => {
        this.title = res.add_role_pricing_scheme_link;
        this.pricing_scheme_text = res.pricing_scheme;
        this.select_pricing_scheme_text = res.select_pricing_scheme;
        this.invalid_entry = res.invalid_entry;
        this.back_button = res.back_button;
        this.save_button = res.save_button;
      });
    } else {
      this.title = 'Add Role Pricing Scheme Link';
      this.pricing_scheme_text = 'Pricing Scheme';
      this.select_pricing_scheme_text = 'Select Pricing Scheme';
      this.invalid_entry = 'Not a valid entry';
      this.back_button = 'Back';
      this.save_button = 'SAVE';
    }
  }

  ngOnInit(): void {
    this.subs.sink = this.localState$.subscribe((a) => {
      this.localState = a;
      this.componentStore.setState({ localState: a });
    });
    this.subs.sink = this.viewColFacade.prevIndex$.subscribe(
      (resolve) => (this.prevIndex = resolve)
    );
    this.subs.sink = this.viewColFacade
      .prevLocalState$()
      .subscribe((resolve) => (this.prevLocalState = resolve));

    this.subs.sink = this.AppletLoginSubjectLink$.subscribe((session) => {
      if (session) {
        this.tenantGuid = session.tenant_guid.toString();
      }
    });

    this.subs.sink = this.userRank$.subscribe((rank) => {
      if (rank) {
        this.rank = rank;
      }
    });

    this.subs.sink = this.store
      .select(RolePermSelectors.selectGuid)
      .subscribe((guid) => {
        if (guid) {
          this.roleGuid = guid;
        }
      });

    this.form = this.fb.group({
      role: ["", Validators.compose([Validators.required])],
      pricingScheme: ["", Validators.compose([Validators.required])],
      currentRole: [""],
      currPricingScheme: [""],
    });

    this.subs.sink = this.tenantRoleService
      .get(AppConfig.apiVisa)
      .subscribe((res) => {
        this.newRoleArr = this.roleArr = res.data.map((d) => d.app_mst_role);
      });

    this.subs.sink = this.pricingSchemeService
      .get(AppConfig.apiVisa)
      .subscribe((res) => {
        this.newPricingSchemeArr = this.pricingSchemeArr = res.data.map(
          (d) => d.bl_fi_mst_pricing_scheme_hdr
        );
      });
  }

  applyRoleFilter(filterValue: string) {
    filterValue = filterValue.trim(); // remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.newRoleArr = this.roleArr.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  applyPricingSchemeFilter(filterValue: string) {
    filterValue = filterValue.trim(); // remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.newPricingSchemeArr = this.pricingSchemeArr.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  onSubmit() {
    let clientSidePermissionPricingSchemeRoleLinkContainerModel: ClientSidePermissionPricingSchemeRoleLinkContainerModel =
      new ClientSidePermissionPricingSchemeRoleLinkContainerModel();

    clientSidePermissionPricingSchemeRoleLinkContainerModel.bl_applet_role_pricing_scheme_link.applet_guid =
      this.appletGuid;
    clientSidePermissionPricingSchemeRoleLinkContainerModel.bl_applet_role_pricing_scheme_link.role_guid =
      this.roleGuid;
    clientSidePermissionPricingSchemeRoleLinkContainerModel.bl_applet_role_pricing_scheme_link.pricing_scheme_guid =
      this.form.value.pricingScheme;
    clientSidePermissionPricingSchemeRoleLinkContainerModel.bl_applet_role_pricing_scheme_link.sales_price_read =
      true;
    clientSidePermissionPricingSchemeRoleLinkContainerModel.bl_applet_role_pricing_scheme_link.sales_price_update =
      true;
    clientSidePermissionPricingSchemeRoleLinkContainerModel.bl_applet_role_pricing_scheme_link.purchase_price_read =
      true;
    clientSidePermissionPricingSchemeRoleLinkContainerModel.bl_applet_role_pricing_scheme_link.purchase_price_update =
      true;

    this.store.dispatch(
      RolePricingSchemeLinkActions.createRolePricingSchemeLinkInit({
        RolePricingSchemeLink:
          clientSidePermissionPricingSchemeRoleLinkContainerModel,
        rank: this.rank,
        tenantGuid: this.tenantGuid,
      })
    );
  }

  onReturn() {
    this.viewColFacade.updateInstance(this.prevIndex, {
      ...this.prevLocalState,
      deactivateAdd: false,
      deactivateList: false,
    });
    this.viewColFacade.onPrev(this.prevIndex);
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
